import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import profilePic from "./projectsBg.jpg";
import axios from "axios";
import api from "../../utils/api";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.6, ease: "easeOut" },
  }),
};

function Profile() {
  const [profile, setProfile] = useState({});

  useEffect(() => {
    const checkUser = async () => {
      const res = await api.get(`/api/current-user`, {
        withCredentials: true,
      });

      setProfile(res.data);
    };

    checkUser();
  }, []);
  return (
    <motion.div
      className=" p-8 shadow-md"
      initial="hidden"
      animate="visible"
      variants={fadeUp}
    >
      {/* Header */}
      <motion.div
        className="flex flex-col items-center text-center"
        variants={fadeUp}
        custom={0}
      >
        <motion.img
          src={profilePic}
          alt="Profile"
          className="w-32 h-32 rounded-full shadow-md"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.8 }}
        />
        <h1 className="text-3xl font-bold mt-4">{profile.name}</h1>
        <p className="text-gray-600">{profile.email}</p>
      </motion.div>

      {/* Contact Info & About */}
      {/* <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        <motion.div className="bg-white p-6 rounded shadow" variants={fadeUp} custom={1}>
          <h2 className="text-lg font-semibold mb-3">Contact Me</h2>
          <p><strong>Phone:</strong> {employee.phone}</p>
          <p><strong>Email:</strong> {profile.email}</p>
          <p><strong>DOB:</strong> {profile.dob}</p>
          <p><strong>Gender:</strong> {employee.gender}</p>
          <p><strong>Location:</strong> {profile.location}</p>
          <p><strong>Address:</strong> {employee.address}</p>
        </motion.div>

        <motion.div className="bg-white p-6 rounded shadow" variants={fadeUp} custom={2}>
          <h2 className="text-lg font-semibold mb-3">About Me</h2>
          <p className="text-sm text-gray-700">{employee.about}</p>
        </motion.div>
      </div> */}

      {/* Experience & Education */}
      {/* <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6"> */}
      {/* <motion.div className="bg-white p-6 rounded shadow" variants={fadeUp} custom={3}>
          <h2 className="text-lg font-semibold mb-3">Job Experience</h2>
          {employee.jobExperience.map((job, i) => (
            <div key={i} className="mb-2">
              <p className="font-semibold">{job.role}</p>
              <p className="text-sm text-gray-600">{job.company}</p>
              <p className="text-xs text-gray-500">{job.years}</p>
            </div>
          ))}
        </motion.div> */}

      {/* <motion.div className="bg-white p-6 rounded shadow" variants={fadeUp} custom={4}>
          <h2 className="text-lg font-semibold mb-3">Education</h2>
          {employee.education.map((edu, i) => (
            <div key={i} className="mb-2">
              <p className="font-semibold">{edu.degree}</p>
              <p className="text-sm text-gray-600">{edu.university}</p>
              <p className="text-xs text-gray-500">{edu.years}</p>
            </div>
          ))}
        </motion.div> */}
      {/* </div> */}

      {/* Skills & References */}
      {/* <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6"> */}
      {/* <motion.div className="bg-white p-6 rounded shadow" variants={fadeUp} custom={5}>
          <h2 className="text-lg font-semibold mb-3">Skills</h2>
          <ul className="list-disc pl-5 text-sm text-gray-700">
            {employee.skills.map((skill, i) => (
              <li key={i}>{skill}</li>
            ))}
          </ul>
        </motion.div> */}

      {/* <motion.div className="bg-white p-6 rounded shadow" variants={fadeUp} custom={6}>
          <h2 className="text-lg font-semibold mb-3">References</h2>
          {employee.references.map((ref, i) => (
            <div key={i} className="mb-2">
              <p className="font-semibold">{ref.name}</p>
              <p className="text-sm text-gray-600">{ref.address}</p>
            </div>
          ))}
        </motion.div> */}
      {/* </div> */}
    </motion.div>
  );
}

export default Profile;
